// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

export default {
  name: 'ansible',
  title: 'label.ansible',
  icon: 'SyncOutlined',
  docHelp: 'ansible-integration.html',
  permission: ['ansibleStatus', 'ansibleListTasks'],
  children: [
    {
      name: 'ansible/configuration',
      title: 'label.ansible.configuration',
      icon: 'setting-outlined',
      docHelp: 'ansible-integration.html#configuration',
      permission: ['ansibleStatus', 'ansibleEnable'],
      component: () => import('@/views/plugins/ansible/ManageAnsible.vue')
    },
    {
      name: 'ansible/task-list',
      title: 'label.ansible.list',
      icon: 'bars-outlined',
      permission: ['ansibleListTasks'],
      component: () => import('@/views/plugins/ansible/ListTasks.vue')
    }
  ]
}
